import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import AnnouncementRecord from 'src/app/interfaces/announcement/AnnouncementRecord';
import GetAnnouncementResponse from 'src/app/interfaces/announcement/GetAnnouncementResponse';
import { AnnouncementService } from 'src/app/services/announcement.service';

@Component({
  selector: 'app-announcement-designer',
  templateUrl: './announcement-designer.component.html',
  styleUrls: ['./announcement-designer.component.scss']
})
export class AnnouncementDesignerComponent implements OnInit {
  designerForm: FormGroup;
  announcementRecord: AnnouncementRecord;
  isCreateFlow: boolean = true;

  constructor(
    private announcementService: AnnouncementService,
    private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.announcementService.getAnnouncements().subscribe((announcementResponse: GetAnnouncementResponse) => {
      const { data } = announcementResponse;
      if (data) {
        this.announcementRecord = data;
        this.isCreateFlow = false;
        this.designerForm.patchValue(data);
      }
    }, (error) => {
      this.toastrService.error(error.message);
    })
    this.designerForm = new FormGroup({
      content: new FormControl('', Validators.required),
      display: new FormControl(false, Validators.required),
      redirect_to: new FormControl(''),
    })
  }

  onSubmit() {
    if (this.designerForm.invalid) {
      this.toastrService.error('Please fill all required fields!');
      return;
    }
    if (this.isCreateFlow) {
      this.announcementService.addAnouncement(this.designerForm.value).subscribe(({ data }) => {
        this.toastrService.success('Announcement created successfully!');
        location.reload();
      }, (error) => {
        this.toastrService.error(error.message);
      })
    }
    else {
      this.announcementService.updateAnnouncement(this.announcementRecord._id, this.designerForm.value).subscribe(({ data }) => {
        this.toastrService.success('Announcement updated successfully!');
        location.reload();
      }, (error) => {
        this.toastrService.error(error.message);
      })
    }
  }
}
